import React from "react";
import { Editor } from "@tinymce/tinymce-react";
import ModulesHooks from "../Hooks/Question/ModulesHooks";
import CodingQuestionEntryHooks from "./Admin/QuestionEntry/CodingQuestionEntry/Hooks/CodingQuestionEntryHooks";

export default function TextArea(Props) {
  const ModulesHks = ModulesHooks();
  const CodingQuestionEntryHks = CodingQuestionEntryHooks();

  const handleEditor = (value, editor) => {
    let label =
      Props.label === "Question Name"
        ? "name"
        : Props.label === "Explanation"
        ? "ansexp"
        : "description";

    ModulesHks.handleInputChange(value, label);
  };

  return (
    <div className="textAreaMainContainer">
      <label htmlFor="textAreaLabel">{Props.label}</label>
      <Editor
        value={Props.value}
        placeholder="Enter your text here..."
        tinymceScriptSrc="/tinymce/tinymce.min.js"
        onEditorChange={Props.handleChange || handleEditor}
        onBlur={Props.onBlur}
        onInit={(evt, editor) =>
          (CodingQuestionEntryHks.editorRef.current = editor)
        }
        init={{
          ...(
    Props.maxHeight && { max_height: Props.maxHeight }
  ),
          readonly: true,
          menubar: false,
          min_height: 150,
          branding: false,
          statusbar: false,
          elementpath: false,
          license_key: "gpl",
          selector: "textarea",
          allow_html_in_named_anchor: true,
          plugins: [
            "link",
            "help",
            "code",
            "lists",
            "image",
            "table",
            "media",
            "anchor",
            "editor",
            "advlist",
            "preview",
            "charmap",
            "wordcount",
            "fullscreen",
            "autoresize",
            "visualblocks",
            "searchreplace",
            "insertdatetime",
          ],
          toolbar:
            "undo redo | blocks | " +
            "bold italic underline forecolor | link | alignleft aligncenter " +
            "alignright alignjustify | bullist numlist outdent indent | " +
            "removeformat | help |",
          content_style:
            "body { font-family:Helvetica,Arial,sans-serif; font-size:14px }",
        }}
      />
    </div>
  );
}
